/**
 * Pure sort-state helpers for admin tables (no React deps so they're trivially
 * unit-testable). Consumed by SortableHeader and the per-page sort wiring.
 */

export type SortOrder = 'asc' | 'desc';

export interface SortState {
  /** Active API sort field, or null when the list is in its default (server) order. */
  field: string | null;
  order: SortOrder;
}

/**
 * Tri-state sort transition for a column click:
 *   inactive → desc → asc → cleared (back to server default).
 *
 * `desc` first is the right default for an admin tool — clicking a column
 * almost always means "show me the newest / highest / most first".
 */
export function nextSort(current: SortState, field: string): SortState {
  if (current.field !== field) return { field, order: 'desc' };
  if (current.order === 'desc') return { field, order: 'asc' };
  return { field: null, order: 'desc' };
}
